import { MainContentLayout } from 'shared/ui/layout';

import { EditOcpiHub } from 'features/ocpi-hub/edit';

export function EditOcpiHubPage() {
  return <MainContentLayout element={<EditOcpiHub />} />;
}
